<template>
  <div>
    <nav-tab class="fix-top">
      <template>
        <router-link tag="div" to="fr" class="tab" replace >
          <span>分润记录</span>
        </router-link>
        <router-link tag="div" to="ds" class="tab" replace >
          <span>打赏记录</span>
        </router-link>
      </template>
    </nav-tab>
    <router-view></router-view>
  </div>
</template>
<script type="text/ecmascript-6">
import NavTab from '@/components/base/nav-tab/nav-tab'
export default {
  components: {
    NavTab
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .fix-top
    background #ffffff
    position fixed
    left 0
    top 0
    width 100%
    z-index 9
</style>



// WEBPACK FOOTER //
// src/components/personal/wallet/wallet-mingxi.vue